export default __webpack_public_path__ + "static/media/water.02a2e44f.jpg";